import { create, StoreApi, UseBoundStore } from 'zustand';

import { SortingState } from '@tanstack/react-table';

import FilterValueArray from 'models/filterValues/FilterValueArray';

import { FilterState } from './types';

export type Sort = {
  id: string;
  desc: boolean;
};

export type SummarizationsFilterState = FilterState<FilterValueArray>;

type SummarizationsActions = {
  setFilters: (filters: SummarizationsFilterState) => void;
  setSort: (sort: SortingState) => void;
  setSearch: (search: string) => void;
};

export type SummarizationsState = {
  filters: SummarizationsFilterState;
  sort: SortingState;
  search: string;
  actions: SummarizationsActions;
};

export function serializeSort(sort: Sort[]): string {
  return sort.map((s) => `${s.id} ${s.desc ? 'desc' : 'asc'}`).join(',');
}

const createSummarizationsStore = (): [
  useStore: UseBoundStore<StoreApi<SummarizationsState>>,
  useActions: () => SummarizationsActions,
] => {
  const useStore = create<SummarizationsState>((set) => ({
    filters: {},
    sort: [{ id: 'createdAt', desc: true }],
    search: '',
    actions: {
      setFilters: (filters) => set({ filters }),
      setSort: (sort) => set({ sort }),
      setSearch: (search) =>
        set({
          search,
          sort: search ? [{ id: 'search', desc: true }] : [{ id: 'createdAt', desc: true }],
        }),
    },
  }));

  const useActions = () => useStore((state) => state.actions);

  return [useStore, useActions];
};

export const [useSummarizationsStore, useSummarizationsActions] = createSummarizationsStore();
